export default __webpack_public_path__ + "static/media/cladding26.6086d989.jpg";